export const SEARCH_CATALOG = 'SEARCH_CATALOG'
export const CACHE_SEARCH_RESULTS = 'CACHE_SEARCH_RESULTS'

export const OPEN_LIBRARY = 'OPEN_LIBRARY'
export const CROSSREF = 'CROSSREF'
export const GOOGLE_BOOKS = 'GOOGLE_BOOKS'
